import $ from 'jquery'
import setNav from 'modules/setnav';

var closeWorksMenu = function() {
  $('.main-menu a, .works-menu a').click(function(){
    if (!$(this).hasClass(".js-works-trigger")){
      $('body').removeClass('js-works-open');
      $('.works-menu').addClass('closed');
      $('.main-menu .js-works-trigger').removeClass('active');
      setNav();
      console.log("close")
    }
  });
}

export default closeWorksMenu;



// WEBPACK FOOTER //
// ./source/scripts/modules/closeworksmenu.js